/*
Akhila 06/16/2023 3075154998 modified report folder path field
Ravi 06/15/2023 3075154998 added show label and placeholder conditionally
Akhila 30/06/2023 3075154998 condtionaly label name change for folder path and file name
Akhila 07/04/2023 3075154998 file name change to file path label placeholder
*/
import {Button, TextField} from '@material-ui/core';
import {Form, Formik} from 'formik';
import React, {useRef} from 'react';
import {useContext} from 'react';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';
import AddRuleSelectField from '../../../../BRE/FormulaRuleGroup/StepperRuleGroup/AddRule/AddRuleSelectField';
import '../../../../BRE/FormulaRuleGroup/StepperRuleGroup/AddRule/styles.scss';


const ReportFolderPath = ({
  handleClose,
  setFieldValues,
  addValues,
  imports = false,
  export: exp,
  exportType,
  isScheduler,
  workqueue,
  moduleType,
  DmModuleType,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  // const placeholderName =  workqueue ? "Work Queue" : "Report";
  const importCondition = exportType === "Import" ? true : false
  const placeholderName =
  isScheduler && moduleType ? moduleType : isScheduler && DmModuleType ? DmModuleType : importCondition ? 'Exception' : exp ? 'Export'  : workqueue ? 'Work Queue' : 'Report';
  const fieldNameTypeOptions = [
    {key: 'Date', value: 'Date - {YYYYMMDD}'},
    {key: 'Date', value: 'Date - {MMDDYYYY}'},
    {key: 'Date', value: 'Date - {YYMMDD}'},
    {key: 'Date', value: 'Date - {MMDDYY}'},
    {key: 'Date', value: 'Date - {YYMM}'},
    {key: 'Date', value: 'Date - {MMYY}'},
    {key: 'DateTime', value: 'Date Time - {MMDDYYYYHHmmSS}'},
    {key: 'ReportCode', value: 'Name - {Name}'},
    {key: 'DateTime', value: 'Executed By - {EXECUTED_BY}'},
  ];
  const ImportsFieldNameTypeOptions = [
    {key: 'Date', value: 'Date - {YYYYMMDD}'},
    {key: 'Date', value: 'Date - {MMDDYYYY}'},
    {key: 'Date', value: 'Date - {YYMMDD}'},
    {key: 'Date', value: 'Date - {MMDDYY}'},
    {key: 'Date', value: 'Date - {YYMM}'},
    {key: 'Date', value: 'Date - {MMYY}'},
    {key: 'DateTime', value: 'Date Time - {MMDDYYYYHHmmSS}'},
    // { key: "ImportManagerCode", value: "Import Manager Code - {IMPORT_MANAGER_CODE}" },
    {key: 'ImportManagerCode', value: 'Name - {Name}'},
    {key: 'DateTime', value: 'Executed By - {EXECUTED_BY}'},
  ];
  const expressionRef = useRef();
  const initialValues = {
    fields: null,
    expression: addValues?.reportpath ?
      addValues?.reportpath :
      addValues?.reportpathDm ?
        addValues?.reportpathDm :
        ' ',
  };

  const handleSubmit = (values) => {
    if (isScheduler) {
      setFieldValues('reportpathDm', values?.expression);
    }
    setFieldValues('reportpath', values?.expression);
    handleClose();
  };

  return (
    <Formik initialValues={initialValues} enableReinitialize onSubmit={handleSubmit}>
      {(props) => {
        const {
          values,
          handleChange,
          setFieldValue,
          resetForm,
        } = props;
        return (
          <Form>
            <div className="col-12">
              <div className="row">
                <AddRuleSelectField
                  label={'Folder Path'}
                  options={imports ? ImportsFieldNameTypeOptions : fieldNameTypeOptions}
                  optionLable={(option) => (option && option?.value ? option?.value : '')}
                  name="fields"
                  placeholder="Select Folder Path"
                  value={values.fields}
                  handleChange={(_, value) => {
                    setFieldValue('fields', value);
                  }}
                  handleInsert={() => {
                    const selectedFunc = values?.fields?.value?.split('-')[1] ?
                      `${values?.fields?.value?.split('-')[1]}` :
                      '';
                    console.log(selectedFunc, 'selectedFunc');
                    const cursorPosition = expressionRef.current.selectionStart;
                    console.log(cursorPosition, 'cursorPosition');
                    if (values.expression) {
                      // let val =
                      //   values.expression?.slice(0, cursorPosition) +
                      //   selectedFunc +
                      //   values.expression.slice(cursorPosition);
                      const val = values.expression?.slice(0) + selectedFunc; // executed line wise values
                      const val1 = val
                        ?.replaceAll(' ', '')
                        .replaceAll('}/', '}')
                        .replaceAll('}', '}/')
                        ?.slice(0, -1);
                      setFieldValue('expression', val1);
                      expressionRef.current.focus();
                    } else {
                      setFieldValue('expression', selectedFunc);
                    }
                  }}
                />
              </div>

              <div className="row my-3 new-standard-textfields reportout-filed">
                <div className="col-md-5 col-lg-4 col-xl-3 form-group">
                  <TextField
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter ${placeholderName} Folder Path Name`}
                    className={` ${classes.labelName}`}
                    label={`${placeholderName} Folder Path Name`}
                    multiline
                    minRows={2}
                    maxRows={2}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    name="expression"
                    value={values.expression}
                    onChange={(e) => {
                      //   setExpression(e?.target?.value);
                      handleChange(e);
                    }}
                    //  onBlur={handleBlur}
                    inputRef={expressionRef}
                    fullWidth
                    // touched={touched.expression}
                    // error={Boolean(touched.expression && errors.expression)}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-center new-standard-textfields mb-3">
                <Button
                  variant="outlined"
                  onClick={() => {
                    resetForm(initialValues);
                    // setErrorMessage(null);
                    // setSuccessMessage(null);
                  }}
                  className={`reset-btn mx-1 ${classes.buttonRoot}`}
                >
                  Reset
                </Button>

                <Button
                  type="submit"
                  variant="outlined"
                  className={`search-btn mx-1 ${classes.buttonRoot} `}
                >
                  Save
                </Button>
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default ReportFolderPath;
